import { BlockchainWorker } from ':fat/messaging/entities/blockchainWorker';
import { MainPage } from ':fat/messaging/entities/mainPage';

export async function sanityCheck() {
  if (typeof SharedArrayBuffer === 'undefined') {
    // This will only be present if the server responds with the following
    // headers:
    //
    //   - Cross-Origin-Opener-Policy: same-origin
    //   - Cross-Origin-Embedder-Policy: require-corp
    //
    // It's also not supported in Safari yet.
    //
    // This is used by absurd-sql. It's not strictly necessary as there is
    // a fallback mode, but concurrent writes are not enabled so if the user
    // were to open the app in multiple tabs, the database could be
    // corrupted. We could likely work around this, but for now we should
    // refuse to continue and only implement a workaround if needed.
    return { success: false, errorMessage: 'SharedArrayBuffer not supported' };
  }

  try {
    await Promise.all([MainPage.actions.ping(), BlockchainWorker.actions.ping()]);
  } catch (error: unknown) {
    let errorMessage = 'Could not ping a neighbor';
    if (error instanceof Error) {
      errorMessage += `: ${error.message}`;
    }
    return { success: false, errorMessage };
  }

  return { success: true };
}
